import { dateFnsLocale } from '@shared/i18n/lib/date-locale';
import { formatInDisplayZone, parseApiDate } from '@shared/lib/format-date';

export const formatDateTime = (iso: string, locale: string): string => {
  const date = parseApiDate(iso);
  if (!date) {
    return iso;
  }

  return formatInDisplayZone(date, 'PP p', { locale: dateFnsLocale(locale) });
};

export const isFutureIso = (iso: string | null | undefined, now = Date.now()): boolean => {
  if (!iso) {
    return false;
  }

  const time = new Date(iso).getTime();
  return !Number.isNaN(time) && time > now;
};

export const retryAfterMinutes = (seconds: number): number => Math.max(1, Math.ceil(seconds / 60));
